import { convertToNumber } from './formatValues';
interface TradeLine {
  include?: boolean;
  isChecked?: boolean;
  accountNumber: string;
  tradelineName: string;
  tradelineBalance: string;
  tradelineMonthlyPayment: string;
  remove?: boolean;
}
export const calculateTotalTradeLineBalance = (tradelineObject: TradeLine[], includeCheckboxes: Record<string, boolean> = {}): number => {
  const total = tradelineObject.reduce((sum, tradeline) => {
    const tradeLineId = tradeline.accountNumber + tradeline.tradelineName + tradeline.tradelineBalance + tradeline.tradelineMonthlyPayment;
    const isIncluded = includeCheckboxes[tradeLineId] || false;
    const balance = convertToNumber(tradeline.tradelineBalance);

    if (isIncluded) {
      return sum + balance;
    }
    return sum;
  }, 0);

  return total;
};
export const calculatePercent = (used: number, amount: number): number => {
  const percent = Math.round(Math.min((used / amount) * 100, 100));
  return percent;
};
export const cashBack = (loanApplication: any, totalUsed: number, selectedLineAmount?: number, selectedDrawAmount?: number, isDrawAmountHidden?: boolean): number => {
  if (loanApplication?.selectedProgramType === 'Home Equity Loan') {
    const lineAmount = selectedLineAmount || loanApplication?.lineAmount || 0;
    return lineAmount - totalUsed;
  } else {
    if (isDrawAmountHidden) {
      const lineAmount = selectedLineAmount || loanApplication?.lineAmount || 0;
      return lineAmount - totalUsed;
    } else {
      const drawAmount = selectedDrawAmount || loanApplication?.drawAmount || 0;
      return drawAmount - totalUsed;
    }
  }
};
